import { Scale, ChevronRight } from "lucide-react";

const BG_IMAGE =
  "https://images.pexels.com/photos/1029622/pexels-photo-1029622.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const roadmap = [
  { label: "Record on Appeal", active: true },
  { label: "Brief Formatting", active: false },
  { label: "Filing Automation", active: false },
  { label: "Document Intelligence", active: false },
  { label: "Full Appellate Platform", active: false },
];

export default function VisionSlide() {
  return (
    <div
      className="h-full w-full relative overflow-hidden"
      data-testid="slide-vision-content"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-[0.03]"
        style={{ backgroundImage: `url(${BG_IMAGE})` }}
      />
      <div className="relative z-10 h-full flex flex-col p-7 sm:p-10 lg:p-12">
        <span className="text-sm font-bold tracking-[0.2em] uppercase text-blue-600 mb-2 font-body">
          VISION
        </span>
        <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-slate-900 mb-8 leading-tight max-w-2xl">
          Build the default operating layer for appellate litigation
        </h1>

        <div className="flex-1 flex flex-col items-center justify-center">
          <div className="flex items-center gap-2 sm:gap-3 flex-wrap justify-center mb-10">
            {roadmap.map((step, i) => (
              <div key={i} className="contents">
                <div
                  className={`px-4 sm:px-5 py-2.5 sm:py-3 rounded-lg border text-center ${
                    step.active
                      ? "bg-blue-600 border-blue-600 text-white"
                      : "bg-white border-slate-200 text-slate-600"
                  }`}
                >
                  <span
                    className={`text-sm font-semibold font-heading ${
                      step.active ? "text-white" : "text-slate-700"
                    }`}
                  >
                    {step.label}
                  </span>
                </div>
                {i < roadmap.length - 1 && (
                  <ChevronRight className="h-4 w-4 text-slate-300 shrink-0" />
                )}
              </div>
            ))}
          </div>

          <p className="text-sm sm:text-base text-slate-500 font-body text-center max-w-lg leading-relaxed">
            Become the software infrastructure for appeals across U.S.
            jurisdictions
          </p>
        </div>

        <div className="flex items-center justify-center gap-3 pb-2">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
            <Scale className="h-4 w-4 text-white" />
          </div>
          <span className="font-heading text-sm font-bold text-slate-900 tracking-tight">
            AppellatePro.AI
          </span>
        </div>
        <div className="text-center pb-2">
          <p className="text-[10px] sm:text-xs text-slate-400 tracking-[0.15em] font-body uppercase">
            mike@appellatepro.ai &middot; 917-724-4968 &middot;
            appellatepro.ai
          </p>
        </div>
      </div>
    </div>
  );
}
